// extracted by mini-css-extract-plugin
module.exports = {"tableBodyRow":"styles_tableBodyRow__1Nx2r","tableBodyRowClickable":"styles_tableBodyRowClickable__DGsSS"};